import React from "react";

// Model Layout Component - MentalHealth
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const mentalLayers = [
  {
    id: "mh0",
    src: "/assets/svgs/mental-health-svgs/mh0.svg",
    alt: "Mental health layered stack",
    style: { left: "52%", top: "34.5%" },
  },
  {
    id: "mh1",
    src: "/assets/svgs/mental-health-svgs/mh1.svg",
    alt: "Continuum of mental health",
    style: { left: "22.5%", top: "14%" },
  },
  {
    id: "mh2",
    src: "/assets/svgs/mental-health-svgs/mh2.svg",
    alt: "Community support factors",
    style: { left: "38%", top: "6%" },
  },
  {
    id: "mh3",
    src: "/assets/svgs/mental-health-svgs/mh3.svg",
    alt: "Stigma and cultural barriers",
    style: { left: "59%", top: "17%", zIndex: 100 },
    tooltip: "Mental Health x Gender",
    tooltipPlacement: "top",
  },
  {
    id: "mh4",
    src: "/assets/svgs/mental-health-svgs/mh4.svg",
    alt: "Psychologists per population",
    style: { left: "73%", top: "25%", zIndex: 90 },
  },
  {
    id: "mh5",
    src: "/assets/svgs/mental-health-svgs/mh5.svg",
    alt: "Mental health facilities and capacity",
    style: { left: "61.9%", top: "71.6%" },
  },
  {
    id: "mh6",
    src: "/assets/svgs/mental-health-svgs/mh6.svg",
    alt: "Mental health workforce gaps",
    style: { left: "33.9%", top: "63.5%" },
  },
  {
    id: "mh7",
    src: "/assets/svgs/mental-health-svgs/mh7.svg",
    alt: "Mental health funding and outreach",
    style: { left: "27.3%", top: "41.3%" },
  },
];

const MentalHealthModel = ({ className = "", showTooltips = true }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      mh1: "key-support",
      mh2: "community-based",
      mh3: "emotional-support",
      mh4: "bangladesh",
      mh5: "nepal",
      mh6: "indonesia",
      mh7: "india",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[1070/859] max-w-[1100px] ${className}`}
        >
          {mentalLayers.map((layer) => {
            const interactive = layer.id !== "mh0";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "right":
                  return "right-full top-1/2 -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-[106%] left-[71%] -translate-x-1/2 -mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${interactive ? "group" : ""
                  }`}
                style={layer.style}
              >
                <div className="relative">
                  <img
                    src={layer.src}
                    alt={layer.alt}
                    loading="lazy"
                    className={`select-none object-contain max-w-max ${interactive
                        ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                        : "pointer-events-none"
                      }`}
                    style={interactive ? { ...hoverTiming } : undefined}
                    {...(interactive ? bounceHandlers : {})}
                    {...(handleClick ? { onClick: handleClick } : {})}
                  />
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default MentalHealthModel;
